<template lang="html">

  <section class="idioma">
    <button @click="requestLangChange">estoy en {{lang}}</button>
  </section>

</template>

<script lang="js">

  import {mapGetters,mapActions} from 'vuex';

  export default  {
    name: 'idioma',
    props: [],
    mounted() {

    },
    data() {
      return {

      }
    },
    methods: {
      ...mapActions(['changeLanguage']),
      requestLangChange : function(){
        this.oldLang = this.getLanguage;
        this.changeLanguage(this.lang)
        .then(r => {
          this.$i18n.locale = r;
          // this.changePath(); 
        }).catch(e =>{
          console.log(e);
        })
      },
    },
    computed: {
      ...mapGetters({
        lang : 'getLanguage'
      })
    }
  }
</script>

<style scoped >
.idioma {

}
</style>



// WEBPACK FOOTER //
// src/components/view-parts/footer/idioma.vue